import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { APIS, USER_DETAILS, USER_CONSTANTS } from 'app/common/constants';
import { BehaviorSubject, of } from 'rxjs';
import { HttpService } from './http.service';
import { DEFAULT_PAGE } from 'app/common/constants';
import { ResponseService } from './response.service';
import { SentryErrorHandler } from './sentry-error-handler.service';
import { catchError } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AuthUserService {
  UserDetails = USER_DETAILS;
  authenticated$ = new BehaviorSubject(null);

  constructor(private router: Router,
              private responseService: ResponseService,
              private sentryService: SentryErrorHandler,
              private httpService: HttpService) {
    this.errorHandler = this.errorHandler.bind(this);
  }

  /** User authenticated or not **/
  isAuthenticated(): boolean {
    if (localStorage.getItem(this.UserDetails.TOKEN)) {
      this.authenticated$.next(true);
      return true;
    }
    return false;
  }

  clearAuthData() {
    localStorage.clear();
    this.router.navigate(['/main']).then(() => null);
  }

  /** User logout **/
  logout() {
    this.httpService.getData(APIS.AUTH.LOGOUT)
      .pipe(
        catchError(e => of(null))
      ).subscribe(r => {
      this.clearAuthData();
    });
  }

  /** Set user details **/
  setUserDetails(id, value) {
    localStorage.setItem(id, value);
    return;
  }

  /** Get user details **/
  getUserDetails(key) {
    return localStorage.getItem(key);
  }

  login(credentials: Record<string, any>) {
    this.httpService.postData(APIS.AUTH.LOGIN, credentials).subscribe((res) => {
      if (res?.user) {
        this.setUserDetails(USER_DETAILS.TOKEN, res?.accessToken);
        this.setUserDetails(USER_DETAILS.ROLE, JSON.stringify(res?.user?.role));
        this.setUserDetails(USER_DETAILS.APPROVED, res?.user?.approved);
        this.setUserDetails(USER_DETAILS.LOCATION, res?.user?.locations[0]?.id);
        this.setUserDetails(USER_DETAILS.ID, res?.user?.id);
        //TODO work on try login logic
        this.setUserDetails(USER_DETAILS.TRY_LOGIN, true);
        this.router.navigate([DEFAULT_PAGE]).then(r => null);
        // this.router.navigateByUrl('/user/users')
      }
    }, this.errorHandler);
  }

  removeItem(key) {
    localStorage.removeItem(key);
  }

  errorHandler(error) {
    if (error?.status === 403) {
      this.responseService.setResponse(
        'your account approval is pending', 'Under Review');

    } else if (error?.status === 423) {
      this.responseService.setResponse(
          'your account approval is pending', 'Account Suspended');

    } else {
      this.responseService.setResponse(
        error?.error?.message ??
        'Unable to connect to the server!',
        'Login Error');
    }
    this.sentryService.handleError(error ?? 'Unable to connect to the server!');
    this.router.navigate(['/not-approved']);
  }
}
